export const STORE_NAME = 'Склад'
export const MIN = 'Минимум'
export const COUNT = 'Остаток'
